export function HeartChartOption(timeArr, xlength, dataArr) {
  //NOSONAR
  return {
    lineStyle: {
      color: '#FF0040',
    },
    itemStyle: {
      normal: {
        color: '#FF0040',
      },
    },
    tooltip: {
      transitionDuration: 0, //加上这个可以防止抖动
      trigger: 'axis',
    },
    xAxis: {
      nameTextStyle: {
        color: '#red',
      },
      type: 'category',
      // boundaryGap: false,
      data: timeArr,
      axisLine: {
        //y轴
        show: false,
      },
      axisTick: {
        //y轴刻度线
        show: false,
      },
      splitLine: {
        //网格线
        show: false,
      },
      axisLabel: {
        textStyle: {
          color: '#ccc', //更改坐标轴文字颜色
        },
        show: true,
        showMinLabel: true,
        showMaxLabel: true,
        interval: xlength,
      },
    },
    yAxis: {
      type: 'value',
      min: 40,
      max: 220,
      // splitNumber: 3,
      interval: 60,
      position: 'right',
      axisLine: {
        //y轴
        show: false,
      },
      axisTick: {
        //y轴刻度线
        show: false,
      },
      axisLabel: {
        textStyle: {
          color: '#ccc', //更改坐标轴文字颜色
        },
      },
    },
    series: [
      {
        data: dataArr,
        type: 'line',
        symbol: 'none',
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(255, 0, 64, 0.3)', // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(255, 0, 64, 0.5)', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
        },
      },
    ],
    grid: {
      top: 10,
      left: 17,
      right: 35,
      bottom: 20,
    },
  }
} //NOSONAR
export function TempChartOption(timeArr, xlength, dataArr) {
  return {
    lineStyle: {
      color: 'rgba(43, 221, 160, 1)',
    },
    itemStyle: {
      normal: {
        color: 'rgba(43, 221, 160, 1)',
      },
    },
    tooltip: {
      transitionDuration: 0, //加上这个可以防止抖动
      trigger: 'axis',
    },
    xAxis: {
      type: 'category',
      data: timeArr,
      boundaryGap: false,
      axisLine: {
        //y轴
        show: false,
      },
      axisTick: {
        //y轴刻度线
        show: false,
      },
      splitLine: {
        //网格线
        show: false,
      },
      axisLabel: {
        textStyle: {
          color: '#ccc', //更改坐标轴文字颜色
        },
        show: true,
        showMinLabel: true,
        showMaxLabel: true,
        interval: xlength,
      },
    },
    yAxis: {
      type: 'value',
      position: 'right',
      min: 60,
      max: 100,
      interval: 15,
      minInterval: 1,
      axisLine: {
        //y轴
        show: false,
      },
      axisTick: {
        //y轴刻度线
        show: false,
      },
      axisLabel: {
        textStyle: {
          color: '#ccc', //更改坐标轴文字颜色
        },
      },
    },
    series: [
      {
        data: dataArr,
        type: 'line',
        symbol: 'none',
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: 'rgba(43, 221, 160, 0.1)', // 0% 处的颜色
              },
              {
                offset: 1,
                color: 'rgba(43, 221, 160, 1)', // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
        },
      },
    ],
    grid: {
      top: 10,
      left: 17,
      right: 35,
      bottom: 20,
    },
  }
} //NOSONAR
